/**
 * Возвращает date-fns Locale для текущего языка приложения
 * (используется в formatDistanceToNow и подобных)
 */
import type { Locale } from 'date-fns';
import { ru, enUS } from 'date-fns/locale';
import i18next from 'i18next';

const DATE_FNS_LOCALE_MAP: Record<string, Locale> = {
  ru,
  en: enUS,
};

/** Возвращает date-fns Locale для текущего языка из i18next */
export function getDateFnsLocale(): Locale {
  const lang = i18next.language || 'ru';
  return DATE_FNS_LOCALE_MAP[lang] ?? enUS;
}